<template>
  <form
    class="subscribe-form"
    @submit.prevent="subscribeWithApi"
  >
    <div class="subscribe-input">
      <input-field
        :type="'email'"
        name="email"
        field="email"
        :error="formErrors.length > 0"
        :error-msg="$t(formErrors[0])"
        :label="$t('footerWide.subscribe.label')"
        :value="email"
        @input="setEmail"
      />

      <span
        v-dompurify-html="$t('privacyPolicyAgreement.subscribe')"
        class="privacy-policy-agreement"
      />
    </div>

    <element-button
      class="btn-blue"
      :text="$t('buttons.submitBtnText')"
      @click.prevent="subscribeWithApi"
    />
  </form>
</template>

<script>
  import SubscribeMixins from 'components/Subscribe/mixins/Subscribe'
  import { mapState } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    name: "SubscribeForm",
    components: {
      'input-field': () => import(/* webpackChunkName: "input-field" */ 'components/Elements/Input'),
      ElementButton: () => import(/* webpackChunkName: "element-button" */ "components/Elements/Button")
    },
    mixins: [
      validationMixin,
      SubscribeMixins
    ],
    props: {
      subscribedRedirectURL: {
        type: String,
        required: true
      },
      subscribeSource: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        email: '',
        formErrors: []
      }
    },
    validations: {
      email: {
        required,
        email
      }
    },
    computed: {
      ...mapState('main', [
        'selectedLang',
        'selectedCountry'
      ])
    },
    methods: {
      setEmail (value) {
        this.$v.email.$model = value

        this.onInput()
        this.onChange()
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .privacy-policy-agreement {
    @include defaultFontValues($blue-light, 12, 20);
    margin-bottom: 16px;

    ::v-deep a {
      color: $blue-medium;
    }

    @include bp-mf-tablet {
      margin-bottom: 0;
    }

    @include bp-mf-desktop {
      font-size: em(14);
    }
  }

  .btn-base {
    margin-top: 12px;
    height: 48px;

    @include bp-mf-tablet {
      margin-top: 6px;
      height: 44px;
      min-width: 135px;
    }

    @include bp-mf-desktop {
      min-width: 170px;
      height: 56px;
      margin-top: 0;
    }
  }

  .subscribe-form {
    display: flex;
    flex-direction: column;

    @include bp-mf-tablet {
      flex-direction: row;
      justify-content: center;
    }

    .subscribe-input {

      @include bp-mf-tablet {
        margin-right: 15px;
        width: 370px;
      }

      @include bp-mf-desktop {
        width: 550px;
      }
    }
  }

</style>
